import * as React from 'react';
import type { IconProps } from './types';

export const CheckmarkFilledIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => {
  const { color = 'currentColor', size = 24, ...other } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" ref={forwardedRef} {...other}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Zm5.402-12.705a.25.25 0 0 0-.025-.356l-1.719-1.463a.25.25 0 0 0-.357.035L9.027 10.9a.25.25 0 0 1-.354.038L6.372 9.055a.25.25 0 0 0-.335.017l-1.422 1.422a.25.25 0 0 0 .009.362l4.06 3.668a.25.25 0 0 0 .354-.02l6.364-7.209Z"
        fill={color}
      />
    </svg>
  );
});
